import ContentFrequentlyAskedQuestions from "../../../ui-components/content-frequently-asked-questions/content-frequently-asked-questions.tsx";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";

import RaindropTextHeading2 from "../../../ui-components/raindrop-text-heading-2/raindrop-text-heading-2.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";

const RaindropSettingsQuestions = () => {
  return (
    <RaindropPage hasBackNavigation={true}>
      <div className="flex flex-col gap-2 px-4 text-left">
        <RaindropTextHeading2>Frequently Asked Questions</RaindropTextHeading2>
        <RaindropTextSubtitle>
          You've got tonnes of questions, and we're here to help. If there is
          something we have missed, remember to{" "}
          <a
            className="font-bold text-color-raindrop-primary"
            href={"/raindrop/feedback"}
          >
            leave feedback so we can improve.
          </a>
        </RaindropTextSubtitle>
      </div>

      <ContentFrequentlyAskedQuestions />
    </RaindropPage>
  );
};

export default RaindropSettingsQuestions;
